// REDUCERS
import {
  SET_BOOKING_URL,
  SET_BOOKING,
  SET_CURRENT_MATSPEC,
  SET_CURRENT_TAB,
  SET_CURRENT_CREATIVE,
  SET_PREFLIGHT_REPORT,
  MODAL_VISIBLE,
  SET_APPROVING,
  SET_SUBMITTING,
  SET_LANGUAGE,
  SET_CONFIGURATION,
  SET_BOOKING_TYPE,
  SET_FIELD_TRANSLATIONS,
  TOGGLE_SPLASH,
  SET_ADMATERIAL,
  SET_FIELDS_TO_SAVE,
  SET_TRANSLATIONS,
  SET_MATSPECS_TO_SUBMIT
} from "../constants";

const initialState = {
  booking: null,
  currentTab: "1",
  fieldsToSave: [],
  matspecsToSubmit: {}
};

const rootReducer = (state = initialState, action) => {
  if (action.type === SET_BOOKING) {
    return { ...state, booking: action.data };
  }
  if (action.type === SET_ADMATERIAL) {
    return { ...state, admaterial: action.data };
  }
  if (action.type === SET_CONFIGURATION) {
    return {
      ...state,
      configuration: action.data,
      tableFields: action.data.tableFields,
      tableFieldsPrint: action.data.tableFieldsPrint
    };
  }
  if (action.type === SET_LANGUAGE) {
    return {
      ...state,
      language: action.data,
      currentLangCode: action.langCode
    };
  }
  if (action.type === SET_TRANSLATIONS) {
    return {
      ...state,
      translations: action.data,
      currentLangCode: action.langCode
    };
  }
  if (action.type === SET_CURRENT_MATSPEC) {
    return { ...state, currentMatspec: action.data };
  }
  if (action.type === SET_CURRENT_TAB) {
    return { ...state, previousTab: state.currentTab, currentTab: action.data };
  }
  if (action.type === SET_CURRENT_CREATIVE) {
    return { ...state, currentCreative: action.data };
  }
  if (action.type === SET_PREFLIGHT_REPORT) {
    return { ...state, preflightReport: action.data };
  }
  if (action.type === MODAL_VISIBLE) {
    return { ...state, modalVisible: action.data };
  }
  if (action.type === SET_APPROVING) {
    return { ...state, approving: action.data };
  }
  if (action.type === SET_SUBMITTING) {
    return { ...state, submitting: action.data };
  }
  if (action.type === SET_BOOKING_TYPE) {
    return { ...state, bookingType: action.data };
  }
  if (action.type === SET_FIELD_TRANSLATIONS) {
    return { ...state, fieldTranslations: action.data };
  }
  if (action.type === TOGGLE_SPLASH) {
    return { ...state, splashVisible: action.data };
  }
  if (action.type === SET_FIELDS_TO_SAVE) {
    return { ...state, fieldsToSave: action.data };
  }
  if (action.type === SET_MATSPECS_TO_SUBMIT) {
    return { ...state, matspecsToSubmit: action.data };
  }
  
  return state;
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js